import axios from "axios";
import React, { useState, useEffect } from "react";

import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherWeekly(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecastData, setForecastData] = useState(null);

  useEffect(() => {
    setLoaded(false);
  }, [props.cityForecast]);

  function showForecast(response) {
    setForecastData(response.data.daily);
    setLoaded(true);
    // console.log(response.data.daily);
  }

  function load() {
    let apiKey = "ta8of46b0a3a9f030b9f4d2457bdb911";
    let city = props.cityForecast;
    let apiURL = `https://api.shecodes.io/weather/v1/forecast?query=${city}&key=${apiKey}&units=metric`;

    axios.get(apiURL).then(showForecast);
  }
  // console.log(props);
  if (loaded) {
    // console.log(forecastData);
    return (
      <div className="weatherForecast">
        <div className="row">
          {forecastData.map(function (dailyForecast, index) {
            if (index < 6) {
              return (
                <div className="col tempCheck" key={index}>
                  <WeatherForecastDay weeklyData={dailyForecast} />
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  } else {
    load();

    return null;
  }
}
